"use client";
import { Fragment } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Button,
  Text,
} from "@chakra-ui/react";
import Link from "next/link";
import { useDashboardLoginURL } from "@/hooks/useDashboardLoginURL";
import { OFFERING_TABLE_DATA } from "../constants";

const OfferingTable = () => {
  const dashboardLoginURL = useDashboardLoginURL();
  const baseBuyNowURL = `${dashboardLoginURL}?next=${encodeURIComponent(`/app/add-product/${OFFERING_TABLE_DATA.product}?os=${OFFERING_TABLE_DATA.base.os}&plan=${OFFERING_TABLE_DATA.base.plan}&frequency=${OFFERING_TABLE_DATA.base.monthlyPrice.frequency}`)}`;
  const proBuyNowURL = `${dashboardLoginURL}?next=${encodeURIComponent(`/app/add-product/${OFFERING_TABLE_DATA.product}?os=${OFFERING_TABLE_DATA.pro.os}&plan=${OFFERING_TABLE_DATA.pro.plan}&frequency=${OFFERING_TABLE_DATA.pro.monthlyPrice.frequency}`)}`;
  const expertBuyNowURL = `${dashboardLoginURL}?next=${encodeURIComponent(`/app/add-product/${OFFERING_TABLE_DATA.product}?os=${OFFERING_TABLE_DATA.expert.os}&plan=${OFFERING_TABLE_DATA.expert.plan}&frequency=${OFFERING_TABLE_DATA.expert.monthlyPrice.frequency}`)}`;

  return (
    <Fragment>
      <TableContainer>
        <Table
          size={{ base: "sm", sm: "lg" }}
          variant={"striped"}
          border={"2px solid rgb(237,242,247)"}
        >
          <Thead>
            <Tr>
              <Th>Description</Th>
              <Th>Base</Th>
              <Th>Pro</Th>
              <Th>Expert</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>Total vCPU</Td>
              <Td>{OFFERING_TABLE_DATA.base.vcpu}</Td>
              <Td>{OFFERING_TABLE_DATA.pro.vcpu}</Td>
              <Td>{OFFERING_TABLE_DATA.expert.vcpu}</Td>
            </Tr>
            <Tr>
              <Td>Total Memory</Td>
              <Td>{OFFERING_TABLE_DATA.base.memory}</Td>
              <Td>{OFFERING_TABLE_DATA.pro.memory}</Td>
              <Td>{OFFERING_TABLE_DATA.expert.memory}</Td>
            </Tr>
            <Tr>
              <Td>Total Disk</Td>
              <Td>{OFFERING_TABLE_DATA.base.disk}</Td>
              <Td>{OFFERING_TABLE_DATA.pro.disk}</Td>
              <Td>{OFFERING_TABLE_DATA.expert.disk}</Td>
            </Tr>
            <Tr>
              <Td>Public IPs</Td>
              <Td>{OFFERING_TABLE_DATA.base.ips}</Td>
              <Td>{OFFERING_TABLE_DATA.pro.ips}</Td>
              <Td>{OFFERING_TABLE_DATA.expert.ips}</Td>
            </Tr>
            <Tr>
              <Td>Concurrent Users</Td>
              <Td>{OFFERING_TABLE_DATA.base.users}</Td>
              <Td>{OFFERING_TABLE_DATA.pro.users}</Td>
              <Td>{OFFERING_TABLE_DATA.expert.users}</Td>
            </Tr>
            <Tr>
              <Td>Price Yearly</Td>
              <Td>
                <Text fontWeight={"550"}>
                  {OFFERING_TABLE_DATA.base.yearlyPrice.price}
                </Text>
              </Td>
              <Td>
                <Text fontWeight={"550"}>
                  {OFFERING_TABLE_DATA.pro.yearlyPrice.price}
                </Text>
              </Td>
              <Td>
                <Text fontWeight={"550"}>
                  {OFFERING_TABLE_DATA.expert.yearlyPrice.price}
                </Text>
              </Td>
            </Tr>
            <Tr>
              <Td>Price Monthly</Td>
              <Td>
                <Text fontWeight={"550"}>
                  {OFFERING_TABLE_DATA.base.monthlyPrice.price}
                </Text>
              </Td>
              <Td>
                <Text fontWeight={"550"}>
                  {OFFERING_TABLE_DATA.pro.monthlyPrice.price}
                </Text>
              </Td>
              <Td>
                <Text fontWeight={"550"}>
                  {OFFERING_TABLE_DATA.expert.monthlyPrice.price}
                </Text>
              </Td>
            </Tr>
            <Tr>
              <Td>Buy Now</Td>
              <Td>
                <BuyNowLink href={baseBuyNowURL} />
              </Td>
              <Td>
                <BuyNowLink href={proBuyNowURL} />
              </Td>
              <Td>
                <BuyNowLink href={expertBuyNowURL} />
              </Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </Fragment>
  );
};

export default OfferingTable;

const linkStyles = {
  padding: "0.75rem 0",
};

const BuyNowLink = ({ href }: { href: string }) => {
  return (
    <Link href={href} style={linkStyles}>
      <Button
        size={{ base: "sm", sm: "md" }}
        bg={"#4299e1"}
        color={"white"}
        _hover={{ backgroundColor: "#0056B3" }}
      >
        Buy
      </Button>
    </Link>
  );
};
